<template>

  <v-card 
    class="mx-auto"
    max-width="700"
  >
    <v-dialog v-model="dialog" max-width="500px">
                
      <v-card>

        <v-toolbar elevation="0">
          <v-card-title>
            <span>{{ formTitle }}</span>
          </v-card-title>

          <v-spacer></v-spacer>

          <v-btn
            icon
            color="red"
            @click="deleteItem(editedItem)"
            v-if="editedIndex > -1"
            title="Borrar"
          >
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </v-toolbar>
      
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-text-field v-model="editedItem.name" label="Ingrese nombre"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="editedItem.categoria"
                  :items="categories"
                  label="Categoria"
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>
            </v-row>

            <v-file-input
              label="Adjunte imagen"
              truncate-length="15"
              v-model="files"
            ></v-file-input>

          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCat" max-width="500px">
                
      <v-card>

        <v-toolbar elevation="0">
        <v-card-title>
          <span>Gestionar categorías</span>
        </v-card-title>

        </v-toolbar>
        
        <v-card-text>
          <v-container>
            <v-list
              subheader
              flat
            >
              <v-subheader>Acciones</v-subheader>

              <div>

                <v-btn
                  class="mx-2"
                  fab
                  outlined
                  x-small
                  color="blue"
                  title="Agregar"
                  @click="editCategory(0)"
                >
                  <v-icon dark>
                    mdi-plus
                  </v-icon>
                </v-btn>

                <v-btn
                  class="mx-2"
                  fab
                  outlined
                  x-small
                  color="grey"
                  title="Cambiar nombre"
                  @click="editCategory(1)"
                >
                  <v-icon dark>
                    mdi-pencil
                  </v-icon>
                </v-btn>

                <v-btn
                  class="mx-2"
                  fab
                  outlined
                  x-small
                  color="red"
                  title="Borrar"
                  @click="deleteCategory()"
                >
                  <v-icon dark>
                    mdi-delete
                  </v-icon>
                </v-btn>

              </div>

              <v-subheader>Categorías</v-subheader>

              <v-list-item-group v-model="model">
                <v-list-item  
                  v-for="item in categories"
                  :key="item.name"
                >
                  <template v-slot:default="{ active, }">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="active"
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>

              </v-list-item-group>
            </v-list>

          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="done">Hecho</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogEdit"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span>{{ editDialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="editedCategory.name" label="Ingrese nombre"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancelEditName()">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="saveCategory()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar elevation="1">
      <v-toolbar-title>Lista de imágenes</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu
        bottom
        left
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :disabled="![1,2].some(r => usuario.groups.includes(r))"
            icon
            v-bind="attrs"
            v-on="on"
            title="Mostrar opciones"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>


          <v-list-item
            @click="editItem(undefined)"
          >
            <v-list-item-icon>
              <v-icon>mdi-upload</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Subir imagen</v-list-item-title>
            </v-list-item-content>

          </v-list-item>

          <v-list-item
            @click="editCategories()"
          >
            <v-list-item-icon>
              <v-icon>mdi-upload</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Gestionar categorías</v-list-item-title>
            </v-list-item-content>

          </v-list-item>

        </v-list>
      </v-menu>

    </v-toolbar>

    <v-row
      class="pa-4"
      justify="space-between"
    >
      <v-col>
        <v-treeview
          :active.sync="active"
          :items="items"
          :open.sync="open"
          activatable
          open-on-click
          shaped
          hoverable
        >
          <template v-slot:prepend="{ item }">
            <v-icon color="indigo" v-if="!item.children" small>
              mdi-image-outline
            </v-icon>
          </template>

          <template v-slot:append="{ item }">
            <span style="color:grey" v-if="item.children">
              {{item.children.length}}
            </span>
          </template>

        </v-treeview>

      </v-col>

      <v-divider vertical></v-divider>

      <v-col
        class="d-flex text-center"
      >
        <v-scroll-y-transition mode="out-in">
          <div
            v-if="!selected"
            class="title grey--text text--lighten-1 font-weight-light"
            style="align-self: center;"
          >
            Seleccione una imagen
          </div>
          <v-card
            v-else
            :key="selected.id"
            class="pt-6 mx-auto"
            flat
            max-width="400"
          >
            <v-card-text>
                <v-img
                  :src="selected.imagen"
                  class="mb-6"
                ></v-img>
              <h3 class="headline mb-2">
                {{ selected.name }}
                <v-btn 
                  :disabled="![1,2].some(r => usuario.groups.includes(r))"
                  @click="editItem(selected)" 
                  icon
                  title="Editar"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </h3>
              <div class="blue--text mb-2">
                {{ category.name }}
              </div>
              <div class="blue--text subheading font-weight-bold">
                <a
                  :href="selected.imagen"
                  target="_blank"
                >{{ selected.imagen }}</a>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            
          </v-card>
        </v-scroll-y-transition>
      </v-col>
    </v-row>
  </v-card>

</template>


<script>

  export default {
    data: () => ({
      active: [],
      activeItem: undefined,
      avatar: null,
      open: [],
      users: [],
      dialog: false,
      dialogCat: false,
      dialogEdit: false,
      editedItem: {
        name: '',
        categoria: 0,
      },
      editedCategory: {
        name: ''
      },
      defaultCategory: {
        name: ''
      },
      files: [],
      editedIndex: -1,
      defaultItem: {
        name: '',
        categoria: 0,
      },
      model: -1,
      editDialogTitle: '',
    }),

    computed: {
      usuario() {
        return this.$store.state.user;
      },
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva imagen' : 'Editar imagen'
      },
      items () {
        return this.$store.state.categorias
      },
      selected () {
        if (!this.active.length) return undefined

        const id = this.active[0]

        return this.children.find(item => item.id === id)
      },
      category () {
        const id = this.selected.categoria
        return this.items.find(item => item.id === id)
      },
      categories () {
        let aux = this.items.map(function(el) {
          var o = Object.assign({});
          o.id = el.id;
          o.name = el.name;
          return o;
        })
        return aux;
      },
      children () {
        let children = [];
        this.items.forEach(item => {
          item.children.forEach(obj => {
            children.push(obj);
          });
        });
        return children;
      },
      selectedItem() {
        if (this.model == -1) {
          return undefined;
        }
        return this.categories[this.model];
      }
    },

    created () {
      this.$store.dispatch('loadCategorias')
    },

    methods: {

      close () {
        this.dialog = false
        this.editedIndex = -1
        this.files = [];
      },

      save () {
        let formData = new FormData();
        if (this.editedIndex > -1) {
          formData.append('id', this.editedItem.id);
        }
        formData.append('file', this.files);
        formData.append('name', this.editedItem.name);
        formData.append('category', this.editedItem.categoria);
        this.$store.dispatch('saveImagen', formData);
        this.close()
        this.editedIndex = -1
        this.files = [];
      },

      editItem (item) {
        
        this.editedIndex = this.children.indexOf(item);
        if (this.editedIndex > -1) {
          this.editedItem = Object.assign({}, item);
        }
        else {
          this.editedItem = Object.assign({}, this.defaultItem);
        }

        this.dialog = true;
      },

      deleteItem (item) {
        confirm('Está seguro que quiere borrar esta imagen?') && this.$store.dispatch('deleteImagen', item);
        this.close()
      },

      editCategories () {
        this.dialogCat = true;
      },

      editCategory (mode) {

        if (mode > 0) {

          let item = this.selectedItem;
          if (item == undefined) {
            confirm('Debe seleccionar un item para editar');
          }
           else {
            this.editDialogTitle = 'Editar categoría';
            this.dialogEdit = true;
            this.editedCategory.id = item.id;
            this.editedCategory.name = item.name;
          }
        }
        else {
          this.editDialogTitle = 'Nueva categoría';
          this.dialogEdit = true;
        }
      },

      done () {
        this.dialogCat = false;
      },

      saveCategory () {
        console.log(this.editedCategory);
        this.$store.dispatch('saveCategoria', this.editedCategory);
        this.dialogEdit = false;
        this.editedCategory = Object.assign({}, this.defaultCategory);
      },

      cancelEditName () {
        this.dialogEdit = false;
        this.editedCategory = Object.assign({}, this.defaultCategory);
      },

      deleteCategory() {
        let item = this.selectedItem;
        if (item == undefined) {
          confirm('Debe seleccionar un item para borrar');
        }
        else {
          confirm('Está seguro que quiere borrar esta categoría?') && this.$store.dispatch('deleteCategoria', item);
        }
      },

    },

  }
</script>


<style scoped>
</style>
